import { render, staticRenderFns } from "./MetadataCoapParameterExtractorConfiguration.vue?vue&type=template&id=5c6ae16c&"
import script from "./MetadataCoapParameterExtractorConfiguration.vue?vue&type=script&lang=ts&"
export * from "./MetadataCoapParameterExtractorConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports